var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { display: "none" }, attrs: { id: "nodeTippy" } },
    [
      Object.keys(_vm.clickedNode).length
        ? _c("div", [
            _vm.clickedNode.isEdge
              ? _c("div", [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.clickedNode.data.name) +
                      "\n        "
                  ),
                ])
              : _vm.clickedNode.classes.indexOf("distribution") != -1 &&
                Object.keys(_vm.clickedPathInfo).length > 0
              ? _c("div", [
                  _c("div", [
                    _c("b", [_vm._v("Logical path: ")]),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        attrs: {
                          target: "_blank",
                          href: _vm.clickedPathInfo.url,
                        },
                      },
                      [_vm._v(_vm._s(_vm.clickedPathInfo.name))]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("b", [_vm._v("Data element: ")]),
                    _vm._v(" "),
                    _vm.clickedPathInfo.data_element.name
                      ? _c(
                          "a",
                          {
                            attrs: {
                              target: "_blank",
                              href: _vm.clickedPathInfo.data_element.url,
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.clickedPathInfo.data_element.name)
                            ),
                          ]
                        )
                      : _c("span", [_vm._v(" - ")]),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("b", [_vm._v("Definition: ")]),
                    _vm._v(" "),
                    _vm.clickedPathInfo.definition
                      ? _c("span", [
                          _vm._v(_vm._s(_vm.clickedPathInfo.definition)),
                        ])
                      : _c("span", [_vm._v("-")]),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("b", [_vm._v("Format: ")]),
                    _vm._v(_vm._s(_vm.clickedPathInfo.format)),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("b", [_vm._v("Data type: ")]),
                    _vm._v(_vm._s(_vm.clickedPathInfo.data_type)),
                  ]),
                ])
              : _vm.clickedNode
              ? _c("div", [
                  _c("div", [
                    _c("b", [_vm._v("Name: ")]),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        attrs: {
                          href: _vm.clickedNode.data.url,
                          target: "_blank",
                        },
                      },
                      [_vm._v(_vm._s(_vm.clickedNode.data.name))]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("b", [_vm._v("Type: ")]),
                    _vm._v(" " + _vm._s(_vm.clickedNode.data.type)),
                  ]),
                  _vm._v(" "),
                  _vm.clickedNode.definition
                    ? _c("div", [
                        _c("b", [_vm._v("Definition: ")]),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.sentenceTrimmer(
                                _vm.clickedNode.data.definition
                              )
                            )
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.hasElement(_vm.clickedNode.classes, [
                    "dataset",
                    "distribution",
                  ])
                    ? _c("div", [
                        _vm.clickedNode.data.hasSource &&
                        !_vm.isRequested(
                          _vm.clickedNode.data.id,
                          "source",
                          _vm.requestedData
                        )
                          ? _c("span", [
                              _c(
                                "button",
                                {
                                  staticClass: "source btn btn-sm btn-primary",
                                  attrs: { type: "button" },
                                },
                                [
                                  _vm._v(
                                    "\n                        Show sources\n                    "
                                  ),
                                ]
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.clickedNode.data.hasGenerated &&
                        !_vm.isRequested(
                          _vm.clickedNode.data.id,
                          "generated",
                          _vm.requestedData
                        )
                          ? _c("span", [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "generated btn btn-sm btn-primary",
                                  attrs: { type: "button" },
                                },
                                [
                                  _vm._v(
                                    "\n                        Show generated data\n                    "
                                  ),
                                ]
                              ),
                            ])
                          : _vm._e(),
                      ])
                    : _vm._e(),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }